import Select from "react-select";
import { compactSelectStyles } from "../../../utils/reactSelectControlStyles.js";
import styles from "../../../styles/Reports.module.css";

const ReportYearSelect = ({
  t,
  reportI18nKeys,
  yearOptions,
  selectedYear,
  onYearOptionChange,
  isDisabled,
}) => (
  <div className={styles.filterItemContent}>
    <label className={styles.label}>{t(reportI18nKeys.YEAR)}</label>
    <Select
      options={yearOptions.map((year) => ({ value: year, label: year }))}
      value={selectedYear ? { value: selectedYear, label: selectedYear } : null}
      placeholder={t(reportI18nKeys.YEAR_PLACEHOLDER)}
      onChange={onYearOptionChange}
      isClearable
      isDisabled={isDisabled}
      styles={compactSelectStyles}
    />
  </div>
);

export default ReportYearSelect;
